var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ce-quote"},[_c('blockquote',{attrs:{"cite":""}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.objectdata.text.replace('<p>','<p>&ldquo;').replace('</p>','&bdquo;</p>'))}}),_c('footer',[_vm._v(_vm._s(_vm.objectdata.quotesource))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }